import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'El "Slide Master" de Filosofía',
    desc: '60 presentaciones visuales (Canva/PPT) listas para proyectar. Diseñadas con estética moderna para capturar la atención visual de tus alumnos desde el primer segundo.',
    value: 'USD 15.00'
  }, {
    num: '02',
    title: 'Banco de Actividades "Anti-IA"',
    desc: 'El sistema de talleres y guías de escritura que las IAs no pueden resolver. Actividades basadas en la experiencia personal, el contexto local y la reflexión crítica profunda.',
    value: 'USD 12.00'
  }, {
    num: '03',
    title: 'El "Video-Club" Filosófico',
    desc: 'Guía cinematográfica con 30 películas y series analizadas bajo conceptos filosóficos. Incluye fichas de trabajo para que ver una peli en clase sea una experiencia académica real.',
    value: 'USD 10.00'
  }, {
    num: '04',
    title: 'Guía de Dinámicas de Debate',
    desc: '20 técnicas de debate grupal para despertar a los grupos más silenciosos. Dinámicas para que todos participen, se escuchen y aprendan a disentir con respeto.',
    value: 'USD 9.00'
  }];
  return <section className="py-5 md:py-6 px-4 bg-brand-dark border-b border-brand-accent/10" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-5" data-id="element-25">
          <div className="inline-flex items-center justify-center bg-brand-accent text-brand-dark font-black px-4 py-1.5 rounded-full mb-3 text-xs shadow-[0_0_20px_rgba(0,255,136,0.5)] tracking-wider uppercase" data-id="element-26">
            <Gift className="w-4 h-4 mr-2" data-id="element-27" />
            Incluidos en tu oferta — sin costo extra
          </div>
          <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-tight" data-id="element-28">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-5" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-lg p-4 md:p-5 border border-brand-accent/20 hover:border-brand-accent/60 transition-colors shadow-[0_4px_15px_rgba(0,0,0,0.5)] relative overflow-hidden" data-id="element-30">
              <div className="absolute top-0 right-0 bg-brand-accent text-brand-dark font-black text-[10px] px-2 py-1 rounded-bl-lg" data-id="element-31">
                BONO {bonus.num}
              </div>
              <div className="flex items-start mb-3 mt-2" data-id="element-32">
                <div className="flex-1" data-id="element-33">
                  <h3 className="text-sm md:text-base font-black leading-tight text-white mb-1.5 uppercase" data-id="element-34">
                    {bonus.title}
                  </h3>
                  <p className="text-[11px] md:text-xs text-gray-400 leading-relaxed font-bold" data-id="element-35">
                    {bonus.desc}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between border-t border-white/10 pt-3 mt-2" data-id="element-36">
                <span className="text-gray-500 line-through font-black text-xs" data-id="element-37">
                  Valor: {bonus.value}
                </span>
                <span className="text-brand-accent font-black text-sm neon-glow" data-id="element-38">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-lg p-4 text-center border-2 border-brand-accent max-w-lg mx-auto shadow-[0_0_20px_rgba(0,255,136,0.2)]" data-id="element-39">
          <p className="text-sm md:text-base font-black text-white uppercase" data-id="element-40">
            Valor total de los 4 Bonos:{' '}
            <span className="line-through text-gray-500" data-id="element-41">USD 46.00</span>
          </p>
          <p className="text-xl md:text-2xl font-black text-brand-accent neon-glow my-1 uppercase" data-id="element-42">
            🎁 GRATIS
          </p>
          <p className="text-[10px] md:text-xs text-gray-400 font-bold uppercase" data-id="element-43">
            Solo en este lanzamiento. Incluidos en la oferta. Siempre.
          </p>
        </div>
      </div>
    </section>;
}